<ng-container *ngIf="{ moveID: moveID$ | async } as vm">
    <a
        class="__contact-us-link u-flex-row u-flex-justify-content-space-between u-padding-left u-padding-right u-flex-align-items-center u-cursor-pointer u-background-white u-border-bottom u-border-gray-ultralight u-text-decoration-none u-color-gray-ultradark u-padding-top-half u-padding-bottom-half"
        [attr.href]="
            contactUsLink.link ? (contactUsLink.link | translate : { isMover: StringUtils.isString(vm.moveID), moveID: vm.moveID }) : null
        "
        target="_blank"
        *ngFor="let contactUsLink of contactUsLinks"
        (click)="onClick(contactUsLink)"
    >
        <div class="u-flex-row u-flex-align-items-center u-font-weight-semi-bold">
            <smvd-ui-svg-illustration class="u-margin-right" [svg]="contactUsLink.icon"></smvd-ui-svg-illustration>
            <div class="u-flex-column u-flex-align-items-start">
                <span>{{ contactUsLink.label | translate }}</span>
                <span
                    *ngIf="contactUsLink.extraInfo"
                    class="js-extra-info u-font-size-12 u-color-info-dark u-border-radius u-background-info-light u-font-weight-normal u-margin-y-axis-xs u-padding-x-axis-xs"
                >{{ contactUsLink.extraInfo | translate }}</span
                >
            </div>
        </div>
        <app-svg [name]="chevronRight"></app-svg>
    </a>
</ng-container>
